<nav
  *ngIf="tenant$ | async as tenant"
  class="navbar navbar-dark navbar-expand-md mb-3"
  id="navbar-new"
  aria-label="Main"
  i18n-aria-label="@@navbar-label-mainNavigation"
>
  <div class="container-fluid">
    <!-- Brand and toggler get grouped for better mobile display -->
    <a class="navbar-brand" [href]="generateClassicUrl()" target="_top">{{
      tenantName
    }}</a>
    <button
      type="button"
      class="navbar-toggler btn-lg"
      [attr.aria-expanded]="!isCollapsed"
      (click)="onToggle()"
    >
      <span class="sr-only" i18n="@@navbar-btn-toggleNavigation"
        >Toggle navigation</span
      >
      <i class="fas fa-bars" aria-hidden="true"></i>
    </button>

    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" [collapse]="isCollapsed">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item qa-home-btn">
          <a
            class="nav-link"
            [href]="generateClassicUrl()"
            target="_top"
            i18n="@@navbar-link-home"
            [tabindex]="isCollapsed ? -1 : 0"
            >Home</a
          >
        </li>
        <li class="nav-item qa-lists-btn">
          <a
            class="nav-link"
            [href]="generateClassicUrl('/mylists')"
            target="_top"
            i18n="@@navbar-link-myLists"
            [tabindex]="isCollapsed ? -1 : 0"
            >My Lists</a
          >
        </li>
        <li class="nav-item qa-bookmarks-btn">
          <a
            class="nav-link"
            [href]="generateClassicUrl('/mybookmarks')"
            target="_top"
            i18n="@@navbar-link-myBookmarks"
            [tabindex]="isCollapsed ? -1 : 0"
            >My Bookmarks</a
          >
        </li>
        <li
          *ngIf="permissions.globals.VIEW_ACQUISITIONS && !isCourseFlowTenancy"
          class="nav-item qa-reviews-btn"
        >
          <a
            class="nav-link"
            [href]="reviewsUrl"
            target="_top"
            i18n="@@navbar-link-reviews"
            [tabindex]="isCollapsed ? -1 : 0"
            >Reviews</a
          >
        </li>
        <!-- Update title param once list data is accessible -->
        <li class="nav-item qa-feedback-btn">
          <a
            class="nav-link"
            [href]="generateClassicFeedbackUrl()"
            target="_top"
            i18n="@@navbar-link-feedback"
            [tabindex]="isCollapsed ? -1 : 0"
            >Feedback</a
          >
        </li>
        <li
          *ngIf="showAdminMenu()"
          dropdown
          class="nav-item dropdown qa-admin-btn"
        >
          <button
            dropdownToggle
            class="nav-link dropdown-toggle qa-admin-dropdown-toggle"
            data-bs-toggle="dropdown"
            type="button"
            [tabindex]="isCollapsed ? -1 : 0"
          >
            <span i18n="@@navbar-adminMenu-btn-admin">Admin</span>
          </button>
          <ul *dropdownMenu class="dropdown-menu">
            <li
              *ngIf="permissions.globals.RESOURCE_METADATA_REFRESH"
              class="qa-metadata-btn"
            >
              <a
                class="dropdown-item"
                [href]="
                  generateClassicUrl('/admin/resourcemetadatarefresh.html')
                "
                target="_top"
                i18n="@@navbar-adminMenu-link-metadataRefresh"
                >Book Metadata Refresh</a
              >
            </li>
            <li
              *ngIf="permissions.globals.HOME_MESSAGE"
              class="qa-home-message-btn"
            >
              <a
                class="dropdown-item"
                [href]="generateClassicUrl('/admin/homepage.html')"
                target="_top"
                i18n="@@navbar-adminMenu-link-homepageMessage"
                >Homepage Message</a
              >
            </li>
            <li
              *ngIf="permissions.globals.UPLOAD_HIERARCHY"
              class="qa-hierarchy-btn"
            >
              <a
                class="dropdown-item"
                [href]="generateClassicUrl('/admin/hierarchy.html')"
                target="_top"
                i18n="@@navbar-adminMenu-link-hiearchyUpload"
                >Hierarchy Upload</a
              >
            </li>
            <li *ngIf="permissions.globals.ACCESS_KEYS" class="qa-access-btn">
              <a
                class="dropdown-item"
                [href]="generateClassicUrl('/admin/access-keys.html')"
                target="_top"
                i18n="@@navbar-adminMenu-link-integrations"
                >Integrations</a
              >
            </li>
            <li
              *ngIf="permissions.globals.REQUEST_ROLLOVER"
              class="qa-rollover-btn"
            >
              <a
                class="dropdown-item"
                [href]="generateClassicUrl('/admin/rollover.html')"
                target="_top"
                i18n="@@navbar-adminMenu-link-timePeriodRollover"
                >Request Time Period Rollover</a
              >
            </li>
            <li *ngIf="canReviewJobs()" class="qa-jobs-btn">
              <a
                class="dropdown-item"
                [href]="generateClassicUrl('/jobs.html')"
                target="_top"
                i18n="@@navbar-adminMenu-link-reviewJobs"
                >Review Jobs</a
              >
            </li>
            <li
              *ngIf="permissions.globals.GRANT_ANY_ROLE"
              class="qa-invites-btn"
            >
              <a
                class="dropdown-item"
                [href]="generateClassicUrl('/roles.html')"
                target="_top"
                i18n="@@navbar-adminMenu-link-rolesAndInvites"
                >Roles & Invites</a
              >
            </li>
            <li
              *ngIf="permissions.globals.ADVANCED_MIS"
              class="qa-advanced-mis-btn"
            >
              <a
                class="dropdown-item"
                [href]="generateClassicUrl('/admin/advanced-mis.html')"
                target="_top"
                i18n="@@navbar-adminMenu-link-advancedMIS"
                >Advanced MIS</a
              >
            </li>
            <li
              *ngIf="permissions.globals.ADMINISTER_SETTINGS"
              class="qa-settings-btn"
            >
              <a
                class="dropdown-item"
                [routerLink]="['3', tenantShortCode, 'settings.html']"
                target="_top"
                i18n="@@navbar-adminMenu-link-settings"
                >Settings</a
              >
            </li>
          </ul>
        </li>
        <li
          *ngIf="
            (permissions.globals.VIEW_REPORTS && tenant?.reports?.length > 0) ||
            showMisDashboardLink()
          "
          dropdown
          class="nav-item dropdown qa-reports-btn"
        >
          <button
            dropdownToggle
            class="nav-link dropdown-toggle qa-reports-dropdown-toggle"
            data-bs-toggle="dropdown"
            type="button"
            [tabindex]="isCollapsed ? -1 : 0"
          >
            <span i18n="@@navbar-reportsMenu-btn-reports">Reports</span>
          </button>
          <ul
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="reports-menu-toggle"
          >
            <li
              *ngIf="showMisDashboardLink()"
              class="qa-management-information-btn"
            >
              <a
                [href]="
                  generateClassicUrl('/reports/management-information.html')
                "
                class="dropdown-item"
                target="_top"
                i18n="@@navbar-reportsMenu-link-managementInformation"
                >Management Information</a
              >
            </li>
            <ng-container *ngIf="permissions.globals.VIEW_REPORTS">
              <li *ngIf="showMisDashboardLink()">
                <hr class="dropdown-divider" />
              </li>
              <li *ngFor="let report of tenant.reports">
                <a
                  class="dropdown-item"
                  target="_top"
                  [href]="generateClassicUrl(report.id)"
                >
                  {{ report.description }}
                </a>
              </li>
            </ng-container>
          </ul>
        </li>

        <ng-container [ngSwitch]="user?.isAnonymous">
          <ng-container *ngSwitchCase="false">
            <li dropdown class="nav-item dropdown qa-profile-btn">
              <button
                id="profile-menu"
                dropdownToggle
                class="nav-link dropdown-toggle qa-profile-dropdown-toggle"
                data-bs-toggle="dropdown"
                type="button"
                [tabindex]="isCollapsed ? -1 : 0"
              >
                <ng-container [ngSwitch]="user.profile ? true : false">
                  <span *ngSwitchCase="false" i18n="@@navbar-btn-createProfile"
                    >Create a Profile</span
                  >
                  <ng-container *ngSwitchDefault>
                    <span>{{ user?.fullName }}</span>
                    <rl-avatar
                      *ngIf="user?.guid"
                      [user]="user.guid"
                      [size]="20"
                    ></rl-avatar>
                  </ng-container>
                </ng-container>
              </button>
              <ul
                *dropdownMenu
                class="dropdown-menu"
                aria-labelledby="profile-menu"
              >
                <ng-container [ngSwitch]="user.profile ? true : false">
                  <li *ngSwitchCase="false">
                    <a
                      [routerLink]="createProfileUrl"
                      [queryParams]="{
                        redirectUrl: originPageRedirectUrl
                      }"
                      class="dropdown-item"
                      target="_top"
                      i18n="@@navbar-link-createProfile"
                    >
                      Create a Profile
                    </a>
                  </li>
                  <li *ngSwitchDefault class="qa-view-profile-btn">
                    <a
                      class="dropdown-item"
                      target="_top"
                      i18n="@@navbar-link-viewProfile"
                      [href]="generateClassicUrl('/myprofile')"
                    >
                      View Profile
                    </a>
                  </li>
                </ng-container>

                <li>
                  <button
                    class="dropdown-item qa-logout-btn"
                    i18n="@@navbar-btn-logOut"
                    (click)="logout()"
                  >
                    Log Out
                  </button>
                </li>
              </ul>
            </li>
          </ng-container>

          <li *ngSwitchCase="true" class="nav-item">
            <a
              (click)="login()"
              class="nav-link qa-login-btn"
              i18n="@@navbar-btn-logIn"
              [tabindex]="isCollapsed ? -1 : 0"
              >Log In</a
            >
          </li>
        </ng-container>

        <li
          *ngIf="activeLocales?.length > 1"
          dropdown
          class="nav-item dropdown qa-lang-btn"
        >
          <button
            dropdownToggle
            class="nav-link dropdown-toggle px-3 qa-lang-dropdown-toggle"
            data-bs-toggle="dropdown"
            type="button"
            [tabindex]="isCollapsed ? -1 : 0"
          >
            <i class="fas fa-globe-americas" aria-hidden="true"></i>
            <span class="nav-icon-label" i18n="@@navbar-btn-language"
              >Language</span
            >
          </button>
          <ul *dropdownMenu class="dropdown-menu">
            <li *ngFor="let locale of activeLocales">
              <a
                target="_top"
                class="dropdown-item"
                [class.disabled]="currentLocale === locale.localeCode"
                [attr.href]="
                  currentLocale === locale.localeCode
                    ? null
                    : generateSwitchLocaleUrl(locale.localeCode)
                "
                [lang]="locale.localeCode"
              >
                {{ locale.label }}
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item">
          <a
            class="nav-link px-3 qa-accessibility-link"
            href="https://support.talis.com/hc/en-gb/articles/17338751557533-Web-Accessibility-Statement"
            target="_blank"
            [tabindex]="isCollapsed ? -1 : 0"
          >
            <i class="fal fa-universal-access" aria-hidden="true"></i>
            <span class="nav-icon-label" i18n="@@navbar-link-accessibility"
              >Accessibility</span
            >
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
